import { render, staticRenderFns } from "./DeclarerTitres.vue?vue&type=template&id=20b3a1ad&scoped=true&"
import script from "./DeclarerTitres.vue?vue&type=script&lang=js&"
export * from "./DeclarerTitres.vue?vue&type=script&lang=js&"
import style0 from "./DeclarerTitres.vue?vue&type=style&index=0&id=20b3a1ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3a1ad",
  null
  
)

export default component.exports